var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-widget"},[_c('div',{staticClass:"white-card-header"},[_vm._t("header")],2),_c('div',{staticClass:"white-card-body"},[_vm._t("content")],2),_c('div',{staticClass:"white-card-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }